import React from 'react';
import CalloutSC from './atoms/Callout';
import Icon from '~lib/frontend/design-system/components/Icon';
const Callout = ({ icon, children }) => (React.createElement(CalloutSC, null,
    icon && React.createElement(Icon, { icon: icon, "$size": '24px', "$color": 'primaryFill', "$marginRight": 'small' }),
    React.createElement("span", null, children)));
export default Callout;
